import { render } from "./IntroToComputer.vue?vue&type=template&id=7d1b68ca&scoped=true"
import script from "./IntroToComputer.vue?vue&type=script&lang=js"
export * from "./IntroToComputer.vue?vue&type=script&lang=js"

import "./IntroToComputer.vue?vue&type=style&index=0&id=7d1b68ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d1b68ca"]])

export default __exports__